import { useEffect, useState } from "react";

import CustomButton from "@/common/customElements/button";
import { LightText } from "@/common/texts";
import { ActivitiesRef } from "@/types/components";
import {
  PRIMARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR,
  WHITE_BUTTON_BORDER_COLOR,
} from "@/utils/constants";

const MAX_ACTIVITY_DURATION = 5;

interface HoursContainerProps {
  valuesState: ActivitiesRef;
  deleteAll: boolean;
}

const HoursContainer: React.FC<HoursContainerProps> = ({
  valuesState,
  deleteAll,
}) => {
  const [selectedHour, setSelectedHour] = useState<number | undefined>(
    valuesState.current?.hours,
  );

  useEffect(() => {
    if (deleteAll) {
      setSelectedHour(undefined);
    }
  }, [deleteAll]);

  const handleSelectHour = (index: number) => {
    if (selectedHour == index + 1) {
      setSelectedHour(undefined);
      delete valuesState.current.hours;
    } else {
      setSelectedHour(index + 1);
      valuesState.current.hours = index + 1;
    }
  };

  return Array.from(Array(MAX_ACTIVITY_DURATION).keys()).map((index) => (
    <CustomButton
      key={index}
      width="62px"
      height="56px"
      onClick={() => {
        handleSelectHour(index);
      }}
      backgroundColor={
        selectedHour == index + 1 ?
          PRIMARY_BUTTON_COLOR
        : SECONDARY_BUTTON_COLOR
      }
      borderColor={WHITE_BUTTON_BORDER_COLOR}
    >
      <LightText>
        {index == MAX_ACTIVITY_DURATION - 1 ? index + 1 + "+" : index + 1}
      </LightText>
    </CustomButton>
  ));
};

export default HoursContainer;
